
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"19","viewBox":"0 0 10 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.83696 3.15648H9.52895V0.294484C8.70973 0.209296 7.8866 0.167238 7.06296 0.168484C4.61497 0.168484 2.94097 1.66248 2.94097 4.39848V6.75647H0.177979V9.96047H2.94097V18.1685H6.25296V9.96047H9.00695L9.42095 6.75647H6.25296V4.71348C6.25296 3.76848 6.50496 3.15648 7.83696 3.15648Z","fill":"#444444"}})])
          )
        }
      }
    